import { Card, Group, Text, TextInput, Select } from '@mantine/core';
import { DateInput, type DateValue } from '@mantine/dates';
import { dateFormat, dateFormatUI, locale } from '@/index';
import { getFetcher } from '@/api/fetchers';
import useSWR from 'swr';
import { type Mapping } from '@/schemas/API/GET/mapping/response';
import { MappingToComboBoxItem } from '@/schemas/converters/mappingShemasConverter';
import dayjs from 'dayjs';

interface PersonInfoCardProps {
  title: string;
  disabled?: boolean;
  formContext: any;
}

export const PersonInfoCard: React.FC<PersonInfoCardProps> = (props) => {
    const form = props.formContext();
  
    const { data: sexMap } = useSWR<Mapping>('mappings/sexes', getFetcher);
  
    return (
      <Card shadow="sm" padding="md" radius="md" withBorder>
        <Text fw={700} size="large">
          {props.title}
        </Text>
        <Group justify="space-between" grow className="flex items-start">

          <TextInput
            variant="filled"
            label="Titul"
            {...form.getInputProps('title')}
            disabled={props.disabled}
          />

          <TextInput
            variant="filled"
            label="Jméno"
            {...form.getInputProps('firstName')}
            disabled={props.disabled}
          />

          <TextInput
            variant="filled"
            label="Příjmení"
            {...form.getInputProps('lastName')}
            disabled={props.disabled}
          />
   
          <DateInput
            variant="filled"
            label="Datum narození"
            valueFormat={dateFormatUI}
            locale={locale}
            value={
              form.values.birthdate
                ? dayjs(form.values.birthdate, dateFormat).toDate()
                : null
            }
            onChange={(date: DateValue) => {
              form.setFieldValue(
                'birthdate',
                date ? dayjs(date).format(dateFormat) : ''
              );
            }}
            error={form.errors.birthdate}
            disabled={props.disabled}
          />

          <Select
            variant="filled"
            label="Pohlaví"
            data={sexMap ? MappingToComboBoxItem(sexMap) : []}
            value={form.values.sex}
            onChange={(value) => form.setFieldValue('sex', value)}
            error={form.errors.sex}
            disabled={props.disabled}
            allowDeselect={false}
          />
        </Group>
      </Card>
    );
  };
  
